<script setup lang="ts">
import usePoolStore from '~~/app/store/pool'

const poolStore = usePoolStore()

const onClickOnNetworkName = () => {
    if (!poolStore.getNetwork) {
        return
    }

    if (window.location !== window?.parent?.location) {
        ;(window.top as Window).postMessage(
            {
                action: 'openUrl',
                url: `networks/${poolStore.getNetwork.slug}`
            },
            document.referrer
        )
    } else {
        return navigateTo(
            getChargemapUrl(`/networks/${poolStore.getNetwork.slug}`),
            { external: true }
        )
    }
}
</script>

<template>
    <div class="text-gray-l-500 text-0.5sm flex my-4">
        <span class="w-1/2 block">
            {{ $t('word.network') }}
        </span>
        <span
            class="text-[#0080C5] cursor-pointer"
            @click="onClickOnNetworkName"
        >
            {{ poolStore.getNetworkName }}
        </span>
    </div>
</template>
